import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { TraitCellDisplayProps } from '../types'

export const WetlandDesignationCellDisplay = ({ value }: { value: any }) => {
  const { t } = useTranslation('@cibo/landmanager/WetlandDesignationEditor')
  if (value == null) return null
  return <Typography>{value.result ? t('yes') : t('no')}</Typography>
}

export const WetlandDesignationCell = ({ traitId, year, params }: TraitCellDisplayProps) => {
  const detail = params.row.findDetail({ traitId, year })
  return <WetlandDesignationCellDisplay value={detail} />
}
